<template>
	<div style="height: 100%">
		<cms-column-json :pid="$cid.shrine.self" tag="page" class="link" v-if="$route.path === '/link'">
			<template slot-scope="shrineScope">
				<zui-header :borderGrey="true" :navConfigList="navConfigList"></zui-header>
				<PageNavigater></PageNavigater>
				<!--景区简介-->
				<div class="jianjie" id="one">
					<div class="title"></div>
					<div class="flex w100 vivify fadeInBottom delay-1000" v-if="shrineScope.json.jingQuJianJie">
						<div class="content">
							<h2>{{ shrineScope.json.jingQuJianJie.title }}</h2>
							<div class="note" v-html="shrineScope.json.jingQuJianJie.note"></div>
							<div class="more" @click="$openNewWindow('/new/link/detail?t=jianjie')">
								<span></span>
								<span></span>
								<span></span>
								<span></span>了解更多&emsp;&emsp;
							</div>
						</div>
						<cms-image animate="scale" :src="shrineScope.json.jingQuJianJie.cover" class="img"></cms-image>
					</div>
				</div>
				<!--标志景点-->
				<div class="jingdian" id="two">
					<div class="title"></div>
					<div class="map">
						<div class="star vivify fadeIn" :class="'delay-'+(index*100)" :style="slide.position"
							v-for="(slide,index) in swiperSlides" :key="index" @click="clickStar(index)">
							<div class="starMask">
								<div class="whiteStar"></div>
								{{ slide.name }}
							</div>
						</div>
					</div>
					<div class="des flex">
						<div class="desCon">
							<h2>{{maptitle}}</h2>
							<p>{{ mapIntro }}</p>
						</div>
						<div class="more" @click="$openNewWindow('/new/link/jingdian?activeIndex='+activeIndex)">
							<span></span>
							<span></span>
							<span></span>
							<span></span>
							了解更多&emsp;&emsp;
						</div>
					</div>
				</div>
				<!--精彩体验-->
				<cms-column-list id="three" :pid="$cid.shrine.zuiJiaTiYan" sort-by="sort" tag="div" class="tiyan">
					<template slot-scope="{ list }">
						<div class="title"></div>
						<div class="img">
							<mouse-hover class="vivify fadeIn" :class="'delay-'+(index*500)" :src="item.cover" v-for="(item,index) in list" :key="item.id" @clickMask="zuiJiaTiYanClick(item)">
								<template slot>
									<h1>{{ item.name }}</h1>
									<p>{{ item.note }}</p>
									<div class="more">了解更多&emsp;&emsp;</div>
								</template>
							</mouse-hover>
						</div>
					</template>
				</cms-column-list>
				<!--双遗产-->
				<cms-column-list id="four" :pid="$cid.shrine.shuangYiChan" tag="div" class="yichan">
					<template slot-scope="{ list }">
						<div class="title"></div>
						<div class="tab-con flex  vivify fadeIn"
							:style="{ backgroundImage: 'url(' + shrineScope.json.shuangYiChan.cover + ')'}"
							v-if="shrineScope.json.shuangYiChan">
							<div class="tab">
								<div class="piaoBg" :class="{ active: shuangYiChanIndex === index }"
									v-for="(item, index) in list" :key="item.id" @click="tab(index)">
									{{ item.name }}
								</div>
							</div>
							<cms-column-list :pid="list[shuangYiChanIndex].id" class="tabItem"
								v-if="list && list.length > 0">
								<template slot-scope="children">
									<div class="item flex vivify fadeInRight" :class="'delay-'+(index*500)" v-for="(child, index) in children.list" :key="child.id"
										@click="shuangYiChanClick(child, list[shuangYiChanIndex])">
										<!-- <cms-image :src="child.cover" class="img"></cms-image> -->
										<!--:style="'background-image: url('+child.cover+')'"-->
										<div class="img"
											:class="shuangYiChanIndex==0?'icon' + (index + 1):'icon' + (index + 5)">
										</div>
										<div class="itemImg">
											<h2>{{ child.name }}</h2>
											<p>{{ child.note }}</p>
										</div>
										<div class="rightArr"></div>
									</div>
								</template>
							</cms-column-list>
						</div>
					</template>
				</cms-column-list>
				<!--美景赏析-->
				<div class="xinshang" id="five">
					<div class="title"></div>
					<div class="bottomBlock flex">
						<cms-article-list :pid="$cid.video" :limit="2" class="left">
							<template slot-scope="{list}">
								<div class="video" :class="{ one: index === 0 }" v-for="(item, index) in list"
									:key="item.id" @click="videoClick(item)">
									<cms-image :src="item.cover" poster="video" animate="scale"></cms-image>
									<div class="mask">{{ item.title }}</div>
									<div class="flex tip">
										<img :src="video" alt="" />
										<span style="margin-left: 10px;">精美视频</span>
									</div>
								</div>

								<cms-article-list :pid="$cid.live" :limit="1" class="video">
									<template slot-scope="{list}">
										<div class="video notop" v-for="item in list" :key="item.id"
											@click="liveClick(item)">
											<cms-image :src="item.cover" poster="video" animate="scale"></cms-image>
											<div class="mask">{{ item.title }}</div>
											<div class="flex tip">
												<img :src="live" alt="" />
												<span style="margin-left: 10px;">实时直播</span>
											</div>
										</div>
									</template>
								</cms-article-list>
							</template>
						</cms-article-list>
						<cms-article-list :pid="$cid.picture" :limit="3" class="right">
							<template slot-scope="{list}">
								<div class="photo" :class="{ one: index === 0 }" v-for="(item, index) in list"
									:key="item.id" @click="pictureClick(item)">
									<cms-image :src="item.cover"></cms-image>
									<div class="flex tip">
										<img :src="photo" alt="" />
										<span style="margin-left: 10px;">精美图片</span>
									</div>
									<div class="hover-cover" :class="{ transt: index === 0, transl: index === 1 }">
										<div class="inner">
											<p class="p1">{{ item.title }}</p>
											<p class="p2">
												<span v-if="item.intro">{{ item.intro }}，</span>
											</p>
										</div>
										<div class="flex tip">
											<img :src="photo" alt="" />
											<span style="margin-left: 10px;">精美图片</span>
										</div>
									</div>
								</div>
							</template>
						</cms-article-list>
					</div>
				</div>
				<zui-footer />
				<CmsVideoPlayer :src="videoSrc" :visible.sync="visible" :poster="poster" />
				<CmsFramePlayer :src="liveSrc" :visible.sync="liveVisible" />
			</template>
		</cms-column-json>
		<router-view v-else></router-view>
	</div>
</template>
<script>
	import './less/elBreadcrumb.css'
	import Logo from '../components/Logo'
	import ZuiButton from '../components/Button'
	import mouseHover from '../components/template/maskSolt.vue'
	import {
		BZJD
	} from '~/enum/BiaoZhiJingDian';
	import {
		getArticle
	} from '~/api/CmsApi';
	import CmsVideoPlayer from "~/components/cms/CmsVideoPlayer.vue";
	import CmsFramePlayer from "~/components/cms/CmsFramePlayer.vue";
	export default {
		components: {
			CmsVideoPlayer,
			CmsFramePlayer,
			Logo,
			ZuiButton,
			mouseHover
		},
		data() {
			return {
				videoSrc: '',
				visible: false,
				liveVisible: false,
				liveSrc: '',
				poster: '',
				shuangYiChanIndex: 0,
				cmsImg: require('../assets/img/gonglue1.jpg'),
				video: require('../assets/img/video.png'),
				live: require('../assets/img/live.png'),
				photo: require('../assets/img/photo.png'),
				activeName: 'second',
				swiperSlides: BZJD,
				maptitle: '',
				activeIndex: 0,
				mapIntro: '',
				navConfigList: [{
						name: "景区<br>简介",
						id: "one",
						height: "668"
					},
					{
						name: "标志<br>景点",
						id: "two",
						height: "1454"
					},
					{
						name: "精彩<br>体验",
						id: "three",
						height: "2159"
					},
					{
						name: "双遗产",
						id: "four",
						height: "3052"
					},
					{
						name: "美景<br>赏析",
						id: "five",
						height: "3958"
					},
				],
				isIE: false
			}
		},
		filters: {
			timeFilter(item) {
				return (item.createTime || item.updateTime).substring(0, 10)
			}
		},
		created() {
			this.maptitle = this.swiperSlides[0].name;
			this.setMapIntro(this.swiperSlides[0].id);
			if (document.documentMode)
				this.isIE = true;
		},
		methods: {
			clickStar(index) {
				this.activeIndex = index
				this.maptitle = this.swiperSlides[this.activeIndex].name;
				this.setMapIntro(this.swiperSlides[this.activeIndex].id);
			},
			setMapIntro(id) {
				this.mapIntro = '';
				getArticle(id).then(res => {
					if (res.code === 0) {
						this.mapIntro = res.data.intro;
					}
				});
			},
			tab(index) {
				this.shuangYiChanIndex = index
			},
			zuiJiaTiYanClick(item) {
				this.$openNewWindow(`/new/link/enjoy?id=${item.id}`);
			},
			shuangYiChanClick(item, parent) {
				if (this.shuangYiChanIndex === 0) {
					this.$openNewWindow(`/new/link/culture?id=${parent.id}&tabId=${item.id}`);
				} else {
					this.$openNewWindow(`/new/link/nature?id=${parent.id}&tabId=${item.id}`);
				}
			},
			videoClick(item) {
				this.videoSrc = item.ext1;
				this.poster = item.cover;
				this.$nextTick(() => {
					this.visible = true;
				})
			},
			liveClick(item) {
				if (this.isIE)
					alert('当前浏览器不支持直播观看，请使用其他浏览器重试')
				else {
					this.liveSrc = item.ext1;
					this.liveVisible = true;
				}
			},
			pictureClick(item) {
				if(document.getElementsByClassName('zui-page')[0].getAttribute("class").includes("mobileClass")){

					this.$openNewWindow(`/new/link/pictureList`);
				}else{
					this.$openNewWindow(`/new/link/pictures?id=${item.id}`);
				}
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/views/link.vue